import React from "react";
import { Box, Skeleton } from "@mui/material";
import { dtGreen } from "../../../shared/themes/redesignTokens";

// ===================================================================
//  SKELETON LOADING — responsive skeleton for map + card areas
// ===================================================================

interface TrackingSkeletonProps {
  isDesktop: boolean;
  isTablet: boolean;
  isPhone: boolean;
}

const TrackingSkeleton: React.FC<TrackingSkeletonProps> = ({
  isDesktop,
  isTablet,
  isPhone,
}) => {
  const mapSkeletonBg = "rgba(16,185,129,0.06)";

  if (isPhone) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "calc(100vh - 120px)",
          backgroundColor: dtGreen.pageBg,
        }}
      >
        <Box sx={{ height: "55%", position: "relative" }}>
          <Skeleton variant="rectangular" height="100%" sx={{ backgroundColor: mapSkeletonBg }} />
          <Box sx={{ position: "absolute", top: 16, left: "50%", transform: "translateX(-50%)" }}>
            <Skeleton variant="rounded" width={120} height={44} sx={{ borderRadius: dtGreen.radius }} />
          </Box>
        </Box>
        <Box sx={{ p: 2, display: "flex", flexDirection: "column", gap: "10px" }}>
          <Skeleton variant="rounded" height={24} width={160} sx={{ borderRadius: dtGreen.radiusSm }} />
          <Skeleton variant="rounded" height={120} sx={{ borderRadius: dtGreen.radius }} />
        </Box>
      </Box>
    );
  }

  if (isTablet) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "calc(100vh - 120px)",
          backgroundColor: dtGreen.pageBg,
        }}
      >
        <Box sx={{ height: "60%" }}>
          <Skeleton variant="rectangular" height="100%" sx={{ backgroundColor: mapSkeletonBg }} />
        </Box>
        <Box sx={{ height: "40%", p: 2, display: "flex", flexDirection: "column", gap: "10px" }}>
          <Skeleton variant="rounded" height={24} width={160} sx={{ borderRadius: dtGreen.radiusSm }} />
          <Box sx={{ display: "flex", gap: "12px" }}>
            <Skeleton variant="rounded" width={280} height={140} sx={{ borderRadius: dtGreen.radius, flexShrink: 0 }} />
            <Skeleton variant="rounded" width={280} height={140} sx={{ borderRadius: dtGreen.radius, flexShrink: 0 }} />
          </Box>
        </Box>
      </Box>
    );
  }

  // Desktop
  return (
    <Box
      sx={{
        display: "flex",
        height: "calc(100vh - 120px)",
        backgroundColor: dtGreen.pageBg,
      }}
    >
      <Box sx={{ width: 320, p: 2, display: "flex", flexDirection: "column", gap: 2 }}>
        <Skeleton variant="rounded" height={32} sx={{ borderRadius: dtGreen.radiusSm }} />
        <Skeleton variant="rounded" height={160} sx={{ borderRadius: dtGreen.radius }} />
        <Skeleton variant="rounded" height={160} sx={{ borderRadius: dtGreen.radius }} />
        <Skeleton variant="rounded" height={100} sx={{ borderRadius: dtGreen.radius }} />
      </Box>
      <Box sx={{ flex: 1 }}>
        <Skeleton variant="rectangular" height="100%" sx={{ backgroundColor: mapSkeletonBg }} />
      </Box>
    </Box>
  );
};

export default React.memo(TrackingSkeleton);
